<shared-status-progression [step]="step()" />
<div class="status-text">
  <div class="status-text-headline">{{ 'SHARED.STATUS_BAR.HEADLINE' | translate }}</div>
  <div class="status-text-info">
    {{ 'SHARED.STATUS_BAR.INFO' | translate }}
    @if (timeInMinutes()) {
      {{ timeInMinutes() }}min
    } @else {
      ...
    }
  </div>
</div>
